module.exports = __webpack_public_path__ + "static/media/AdobeXD.a01afc57.svg";